/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleCalculate extends models.BillingRule {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleCalculate");
    }

    getFixupPrototypeFunction() { return BillingRuleCalculate.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleCalculate>): BillingRuleCalculate {
        let obj = Object.assign(new BillingRuleCalculate(), model);
        BillingRuleCalculate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleCalculate>): BillingRuleCalculate {
        if (!model) return null;
        return BillingRuleCalculate.newInstance(<BillingRuleCalculate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleCalculate) {
        if (!obj) return;

        models.BillingRuleCalculate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleCalculate): boolean {
        if (models.BillingRule.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleCalculate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Metric for the calculation
     */
    metric: string;

}
